import { render } from "./1.HelloPage.vue?vue&type=template&id=0ff7dd4f&scoped=true"
import script from "./1.HelloPage.vue?vue&type=script&lang=js"
export * from "./1.HelloPage.vue?vue&type=script&lang=js"

import "./1.HelloPage.vue?vue&type=style&index=0&id=0ff7dd4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff7dd4f"]])

export default __exports__